import PropTypes from 'prop-types'
import React, { Component } from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import MultiTimeSelect from '../MultiTimeSelect'
import { Hours } from 'components/Customize/Availability/Constants'
import Toggle from 'components/Toggle'
import { patchOperations } from 'utils/PatchHelper'
import { SectionItem } from '../../Section'

import style from './style.styl'

class OnlineHours extends Component {
  static propTypes = {
    initialOpenHours: ImmutablePropTypes.listOf(Hours).isRequired,
    initialAvailabilityBasedOnline: PropTypes.bool,
  }

  static defaultProps = {
    initialAvailabilityBasedOnline: false,
  }

  constructor(props) {
    super(props)

    this.state = {
      openHours: this.props.initialOpenHours,
      availabilityBasedOnline: this.props.initialAvailabilityBasedOnline,
    }
  }

  handleTimeSelect = (index, key, value) => {
    const { openHours } = this.state
    const updatedOpenHours = openHours.setIn([index, key], value)
    this.submitHours(updatedOpenHours)
  }

  handleAddTime = () => {
    const { openHours } = this.state
    const updatedOpenHours = openHours.push(Hours())
    this.submitHours(updatedOpenHours)
  }

  handleRemoveTime = (index) => {
    const { openHours } = this.state
    const updatedOpenHours = openHours.delete(index)
    this.submitHours(updatedOpenHours)
  }

  submitHours = (updatedOpenHours) => {
    const { initialOpenHours } = this.props

    const updatedObject = {
      theme: {
        openHours: updatedOpenHours.toJS()
      }
    }
    const initialObject = {
      theme: {
        openHours: initialOpenHours.toJS()
      }
    }

    this.setState({ openHours: updatedOpenHours })

    const changes = patchOperations(updatedObject, initialObject)
    this.props.updateEmbed(changes)
  }

  handleToggleTeamAvailability = (event) => {
    const availabilityBasedOnline = event.target.checked
    const { initialAvailabilityBasedOnline } = this.props

    const updatedObject = {
      theme: {
        availabilityBasedOnline,
      }
    }
    const initialObject = {
      theme: {
        availabilityBasedOnline: initialAvailabilityBasedOnline,
      }
    }

    this.setState({ availabilityBasedOnline })
    const changes = patchOperations(updatedObject, initialObject)
    this.props.updateEmbed(changes)
  }

  render() {
    const { openHours, availabilityBasedOnline } = this.state

    return (
      <div className={style.OnlineHours}>
        <SectionItem title="Online Hours">
          <MultiTimeSelect
            openHours={openHours}
            onSelection={this.handleTimeSelect}
            onAddTime={this.handleAddTime}
            onRemoveTime={this.handleRemoveTime}
          />
        </SectionItem>
        <div className="team-availability-container">
          <SectionItem
            title={`Go Offline when all users in ${this.props.orgName || 'your company'} are Away`}
            description="Drift will automatically go offline when all users in your organization are Away. Scheduled hours will resume when a user becomes Active." />
          <div className="team-availability-toggle">
            <Toggle checked={availabilityBasedOnline} onChange={this.handleToggleTeamAvailability} />
          </div>
        </div>
      </div>
    )
  }
}


export default OnlineHours



// WEBPACK FOOTER //
// ./src/scripts/components/settings/ChatWidget/components/HoursAndTargeting/OnlineHours/index.js